class Room {
    id: number;
    name: string;
    number: string;

    constructor(id: number, name: string, number: string) {
        this.id = id;
        this.name = name;
        this.number = number
    }
}

export default Room;